<h2>PEP - Person i politiskt utsatt ställning</h2>
<spb-politically-exposed
  [(model)]="model"
/>
